// session-facade.js — 会话用例
import * as api from "../transport/api/session-api.js";
import * as store from "./stores/session-store.js";

// T5: 当前会话上下文 token 信息 { estimatedTokens, maxTokens, truncated }
let currentContext = null;

export async function loadSessions({ status = "ACTIVE", keyword = null } = {}) {
  const { sessions, total } = await api.listSessions({ status, limit: 50, keyword });
  store.setSessions(sessions, total);
}

export async function createSession({ roleCode, title }) {
  const { session } = await api.createSession({ roleCode, title });
  store.upsertSession(session);
  store.setCurrentSession(session);
  return session;
}

export async function openSession(id) {
  return api.getSession(id); // { session, messages, context }
}

export function applySessionContext(context) {
  currentContext = context || null;
}

/**
 * 仅获取会话快照，不改变当前会话。
 * 供跨窗口同步使用，避免一个延迟返回的同步请求覆盖用户刚切换的会话。
 */
export async function fetchSessionSnapshot(id) {
  return api.getSession(id);
}

// T5: 获取当前会话上下文 token 信息(由后端返回,含 maxTokens)
export function getCurrentContext() {
  return currentContext;
}

export function clearCurrentContext() {
  currentContext = null;
}

export async function archiveSession(id) {
  await api.archiveSession(id);
  store.removeSession(id);
}

export async function listAdminSessions(opts) {
  return api.listAdminSessions(opts);
}

export { store as sessionStore };
